export const clientId = '471569879015-povuetcdj12ofqae7vd2g062i7380qe1.apps.googleusercontent.com';

export const authorizedUserEmails = [
  'johnshenk77@gmail.com',
  'chadedwardslive@gmail.com',
  'jamesschneeberg@gmail.com',
];